import { Component, OnInit } from '@angular/core';
import { ContractsWarrantiesService } from '../../../Services/contracts-warranties.service';
import { DtoWarrantyForViewVM } from '../../../Model/contracts-warranties/DtoWarrantyForViewVM';
import { AuthService } from '../../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DtoContractClientForViewVM } from '../../../Model/contracts-warranties/DtoContractClientForViewVM';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';

@Component({
  selector: 'app-contracts-warranties',
  templateUrl: './contracts-warranties.component.html',
  styleUrl: './contracts-warranties.component.scss'
})
export class ContractsWarrantiesComponent implements OnInit {
  ContractsList!: DtoContractClientForViewVM[];
  WarrantiesList!: DtoWarrantyForViewVM[];

  ContractClients: string[] = [];
  WarrantyClients: string[] = [];

  selectedContractClientName?: string = '';
  selectedWarrantyClientName?: string = '';

  ContractProductList: DtoContractClientForViewVM[] = [];
  WarrantyProductList: DtoWarrantyForViewVM[] = [];

  isContracts: boolean = false;

  private destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private api: ContractsWarrantiesService, private auth: AuthService, private router: Router,
    private spinner: NgxSpinnerService, private toastrService: CustomToastrService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.GetAllContracts();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ShowProducts(linkName?: string, clientName?: string) {
    if (linkName == "contract") {
      this.isContracts = true;
      this.ContractProductList = [];
      this.selectedContractClientName = clientName;
      this.ContractsList.filter((p: DtoContractClientForViewVM) => p.clientName === clientName).map((p: DtoContractClientForViewVM) => {
        this.ContractProductList.push(p);
      });
    }
    else {
      this.isContracts = false;
      this.WarrantyProductList = [];
      this.selectedWarrantyClientName = clientName;
      this.WarrantiesList.filter((p: DtoWarrantyForViewVM) => p.clientName === clientName).map((p: DtoWarrantyForViewVM) => {
        this.WarrantyProductList.push(p);
      });
    }

    this.spinner.hide();
  }

  GetAllContracts() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.api.GetAllContracts()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.ContractsList = data.payload;
              //const GroupedContractsList = this.shared.groupBy<DtoContractClientForViewVM>(data.payload, (p: DtoContractClientForViewVM) => p.clientName);
              this.ContractsList.map((a: DtoContractClientForViewVM) => {
                if (!this.ContractClients.includes(a.clientName!)) {
                  if (this.selectedContractClientName == '') {
                    this.selectedContractClientName = a.clientName;
                    this.ShowProducts('contract', a.clientName);
                  }

                  this.ContractClients.push(a.clientName!);
                }
              });

              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllWarranties() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Gallery])) {
      this.spinner.show();
      this.api.GetAllWarranties()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (data: any) => {
              this.WarrantiesList = data;
              this.WarrantiesList.map((a: DtoWarrantyForViewVM) => {
                if (!this.WarrantyClients.includes(a.clientName!)) {
                  if (this.selectedWarrantyClientName == '') {
                    this.selectedWarrantyClientName = a.clientName;
                    this.ShowProducts('warranty', a.clientName);
                  }

                  this.WarrantyClients.push(a.clientName!);
                }
              });

              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  tabClick(tab: any) {
    if (tab.index == 0) {
      this.GetAllContracts();
      this.isContracts = true;
      this.ContractProductList = [];
      this.selectedContractClientName = '';
    }
    else if (tab.index == 1) {
      this.GetAllWarranties();
      this.isContracts = false;
      this.WarrantyProductList = [];
      this.selectedWarrantyClientName = '';
    }
  }
}
